import * as Sentry from "@sentry/react";

export const initSentry = () => {
  Sentry.init({
    dsn: window.SENTRY_FRONTEND_DSN,
    integrations: [Sentry.extraErrorDataIntegration()],

    // Doesn't look relevant to our code
    // https://sentry.io/answers/react-resizeobserver-loop-completed-with-undelivered-notifications/
    ignoreErrors: [
      "ResizeObserver loop limit exceeded",
      "ResizeObserver loop completed with undelivered notifications."
    ]
  });
  document.addEventListener("DOMContentLoaded", function () {
    const userId = document.querySelector("body")?.dataset.userId;
    if (userId) {
      Sentry.setUser({ id: userId });
    }
  });
};
